import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CopyButton } from '_components';
import { DiagnosisSearch } from '_components/DiagnosisSearch';
import styles from './Common.module.css'
import { alertActions, patientActions } from '_actions';
import { PatientCareCenterNoteChargesDiagRow } from './DiagRow';

class PatientCareCenterNoteChargesDiagnosis extends React.Component {


    componentDidMount() {
        this.checkSequelae();
    }

    componentDidUpdate(prevProps) {
        this.checkSequelae();
    }

    checkSequelae() {
        if (this.props.medDiags.length > 0
            && this.props.medDiags[0].diag.length === 7
            && this.props.medDiags[0].diag.endsWith('S')) {
            this.props.removeDiag(this.props.epno, this.props.medDiags[0].diag, this.props.medDiags[0].type, this.props.medDiags[0].id);
        }
    }

    onAddDiag(type, val) {
        if (type === 'med') {
            if (!val || val === '') {
                this.props.alertError('You must select a diagnosis before you can add it.');
                return;
            }
            if (this.props.medDiags.length === 6) {
                this.props.alertError('All of the corresponding diagnosis slots are full.  You must first remove an existing diagnosis.');
                return;
            }
            if (Object.keys(this.props.medDiags)
                .find(key => (this.props.medDiags[key].diag === val)) !== undefined ? true : false) {
                this.props.alertError('The specified diagnosis already exists.');
                return;
            }
            if (this.props.medDiags.length === 0 && val.length === 7 && val.endsWith("S")) {
                this.props.alertError('A Sequelae code cannot be the first ICD10');
                return;
            }
            this.props.addDiag(this.props.epno, val, 'Medical');
        } else {
            if (!val || val === '') {
                this.props.alertError('You must select a diagnosis before you can add it.');
                return;
            }
            if (this.props.trtDiags.length === 6) {
                this.props.alertError('All of the corresponding diagnosis slots are full.  You must first remove an existing diagnosis.');
                return;
            }
            if (Object.keys(this.props.trtDiags)
                .find(key => (this.props.trtDiags[key].diag === val)) !== undefined ? true : false) {
                this.props.alertError('The specified diagnosis already exists.');
                return;
            }
            this.props.addDiag(this.props.epno, val, 'Treatment');
        }

    }

    copyDiags() {
        this.props.copyAllDiag(this.props.epno);
    }

    render() {
        return (
            <div className={styles.row}>
                <div className={styles.diag_section_wrapper}>
                    <span className={styles.row}>
                        <span className={styles.diag_search}>
                            <DiagnosisSearch epno={this.props.epno} onAddDiag={(val) => this.onAddDiag('med', val)} trtDiagSearch={false} />
                        </span>
                    </span>
                    <span className={styles.header_wrapper}>
                        <span className={this.props.scribing ? styles.header_row_scribe : styles.header_row}>
                            <span className={styles.header_col1}>Medical Diagnosis</span>
                            {this.props.requireOnsets &&
                                <span className={styles.header_col2}>Onset</span>
                            }
                        </span>
                    </span>

                    {this.props.medDiags.length === 0 &&
                        <span className={styles.no_diag_row}>No Diagnosis Selected</span>
                    }

                    {Object.keys(this.props.medDiags)
                        .map(id => {
                            const diag = this.props.medDiags[id];
                            return (
                                <PatientCareCenterNoteChargesDiagRow key={diag.id} id={diag.id} />
                            )
                        })
                    }



                </div>
                <div className={styles.copy_wrapper}>
                    <CopyButton size='large' title='Copy Diagnosis' onClick={() => this.copyDiags()} />
                </div>
                <div className={styles.diag_section_wrapper}>
                    <span className={styles.row}>
                        <span className={styles.diag_search}>
                            <DiagnosisSearch epno={this.props.epno} onAddDiag={(val) => this.onAddDiag('trt', val)} justify='right' trtDiagSearch={true} />
                        </span>
                    </span>
                    <span className={styles.header_wrapper}>
                        <span className={this.props.scribing ? styles.header_row_scribe : styles.header_row}>
                            <span className={styles.header_col1}>Treatment Diagnosis</span>
                            {this.props.requireOnsets &&
                                <span className={styles.header_col2}>Onset</span>
                            }
                        </span>
                    </span>

                    {this.props.trtDiags.length === 0 &&
                        <span className={styles.no_diag_row}>No Diagnosis Selected</span>
                    }

                    {Object.keys(this.props.trtDiags)
                        .map(id => {
                            const diag = this.props.trtDiags[id];
                            return (
                                <PatientCareCenterNoteChargesDiagRow key={diag.id} id={diag.id} />
                            )
                        })
                    }

                </div>
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        alertError: bindActionCreators(alertActions.error, dispatch),
        alertWarning: bindActionCreators(alertActions.warningMsg, dispatch),
        addDiag: bindActionCreators(patientActions.addDiag, dispatch),
        removeDiag: bindActionCreators(patientActions.removeDiag, dispatch),
        copyAllDiag: bindActionCreators(patientActions.copyAllDiag, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let requireOnsets = state.entities.admissions[epno].requireDiagOnsets;
    let medDiags = Object.keys(state.entities.diagnosis)
        .filter(key => { return state.entities.diagnosis[key].epno === epno && state.entities.diagnosis[key].type === 'Medical' })
        .sort((a, b) => state.entities.diagnosis[a].position - state.entities.diagnosis[b].position)
        .map(key => state.entities.diagnosis[key]);
    let trtDiags = Object.keys(state.entities.diagnosis)
        .filter(key => { return state.entities.diagnosis[key].epno === epno && state.entities.diagnosis[key].type === 'Treatment' })
        .sort((a, b) => state.entities.diagnosis[a].position - state.entities.diagnosis[b].position)
        .map(key => state.entities.diagnosis[key]);

    let addUser = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVADDUSER : state.entities.notes.PTNOTE[pk].NTADDUSER;
    let scribing = addUser === state.entities.authentication.user.urno ? false : true;

    return {
        noteId,
        epno,
        requireOnsets,
        medDiags,
        trtDiags,
        scribing
    };
}

const connectedPatientCareCenterNoteChargesDiagnosis = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteChargesDiagnosis);
export { connectedPatientCareCenterNoteChargesDiagnosis as PatientCareCenterNoteChargesDiagnosis };

